const handlePrint = (text: string) => {
  const newWin = window.open("/");

  if (newWin) {
    newWin.document.write(`<pre>${text}</pre>`);

    newWin.print();
    newWin.close();
  }
};

export default handlePrint;
